/**
 * Domain validation and normalization utilities
 */

export interface DomainValidationResult {
  domain: string;
  isValid: boolean;
  error?: string;
}

/**
 * Normalize domain input - strips protocols, www, paths, ports
 */
export function normalizeDomain(input: string): DomainValidationResult {
  let domain = input.trim().toLowerCase();

  // Remove protocol
  domain = domain.replace(/^https?:\/\//, '');

  // Remove www. prefix
  domain = domain.replace(/^www\./, '');

  // Remove trailing slashes and paths
  domain = domain.split('/')[0];

  // Remove port
  domain = domain.split(':')[0];

  if (!domain) {
    return { domain: '', isValid: false };
  }

  // Validate format
  const domainRegex = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/;
  if (!domainRegex.test(domain)) {
    return { domain, isValid: false, error: 'Enter a valid domain (e.g., example.com)' };
  }

  return { domain, isValid: true };
}

/**
 * Construct full URL for a domain
 */
export function getDomainUrl(domain: string, type: 'subdomain' | 'custom', rootDomain: string): string {
  if (type === 'custom') {
    return `https://${domain}`;
  }
  return `https://${domain}.${rootDomain}`;
}

/**
 * Format a domain for display (adds root domain suffix for subdomains)
 */
export function formatDomainDisplay(domain: string, type: 'subdomain' | 'custom', rootDomain: string): string {
  if (type === 'subdomain') {
    return `${domain}.${rootDomain}`;
  }
  return domain;
}
